import React, { useState, useEffect } from 'react';
import {
  TextField, MenuItem, Button, Box, Typography, Grid, Paper, Dialog, DialogTitle, DialogContent, DialogActions, Avatar,InputAdornment,IconButton
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LayoutLandingHeader from '../components/LayoutLandingHeader';
import LayoutAdminHeader from '../components/LayoutAdminHeader';
import GSTLoader from '../components/GSTLoader'; // Import GSTLoader 
import { Visibility, VisibilityOff } from '@mui/icons-material';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const AddPayment = () => {
  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = Boolean(id);

  const [showForm, setShowForm] = useState(false);
  const [districts, setDistricts] = useState([]);
  const [existingLogo, setExistingLogo] = useState(null);
  const [orderAmount, setOrderAmount] = useState(0);
  const [ifscValid, setIfscValid] = useState(true);
  const [showPassword, setShowPassword] = useState(false); 
  const [showConfirmPassword, setShowConfirmPassword] = useState(false); 

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    emailId: '',
    password: '',
    confirmPassword: '',
    mobileNumber: '',
    alternateMobileNumber: '',
    accountHolderName: '',
    accountNumber: '',
    ifscCode: '',
    bankBranch: '',
    bankName: '',
    gst: '',
    state: '',
    district: '',
    firmName: '',
    address: '',
    pinCode: '',
    companyLogo: null,
    stateName: '',
    districtName: '',
    stateCode: '',
    createdBy: 'admin',
    updatedBy: 'admin',
    securityQuestion: '',   
    securityAnswer: '',  
  });

  const handleClickShowPassword = () => setShowPassword((prev) => !prev); 
  const handleClickShowConfirmPassword = () => setShowConfirmPassword((prev) => !prev); 

  useEffect(() => {
    const fetchStateFromGST = async () => {
      const gst = formData.gst;
      if (gst && gst.length >= 2) {
        const stateCode = gst.substring(0, 2);
        try {
          // const token = localStorage.getItem("token");
          const res = await axios.get(
  `${BASE_URL}/State/GetStateNameByCode/${stateCode}`);
          if (res.data.success) {
            const stateData = res.data.data;
            setFormData(prev => ({
              ...prev,
              state: stateData.id,
              stateName: stateData.stateName,
            }));
          } else {
            setFormData(prev => ({
              ...prev,
              state: '',
              stateName: '',
            }));
          }
        } catch (err) {
          console.error('Error fetching state:', err);
          setFormData(prev => ({
            ...prev,
            state: '',
            stateName: '',
          }));
        }
      }
    };

    fetchStateFromGST();
  }, [formData.gst]);


  useEffect(() => {
    if (formData.state) {
      const fetchDistricts = async () => {
        try {

const res = await axios.get(
  `${BASE_URL}/District/GetDistrictsByState/${formData.state?.id || formData.state}`
);
          setDistricts(res.data.data || []);
        } catch (err) {
          console.error('Failed to fetch districts:', err);
          toast.error('Failed to load districts');
        }
      };
      fetchDistricts();
    } else {
      setDistricts([]);
    }
  }, [formData.state]);

  useEffect(() => {
    if (isEdit) {
      const fetchRegistration = async () => {
        try {
          const token = localStorage.getItem("token");

const res = await axios.get(
  `${BASE_URL}/Registration/GetRegistration/${id}`);
          if (res.data.success) {
            const data = res.data.data;
            setFormData({
              ...data,
              district: data.district?._id || data.district, // ensure it's an ID
              state: data.state?._id || data.state,           // do the same for state
              password: '', // Do not prefill password
              confirmPassword: '', // Do not prefill confirmPassword
            });
            setExistingLogo(data.companyLogo);
            setShowForm(true);
          } else {
            toast.error('Failed to load registration data');
          }
        } catch (err) {
          console.error('Failed to fetch registration:', err);
          toast.error('Failed to load registration data');
        }
      };
      fetchRegistration();
    }
  }, [id, isEdit]);
  
  useEffect(() => {
  const fetchBankDetails = async () => {
    const ifsc = formData.ifscCode?.trim();

    if (ifsc && ifsc.length === 11) {
      try {
        const token = localStorage.getItem("token");

const res = await axios.get(
  `${BASE_URL}/BankDetails/GetNameBranchBasedOnIFSC/${ifsc}`
);
        const data = res.data.data;

        if (res.data.success && data) {
          setFormData(prev => ({
            ...prev,
            bankName: data.BankName,
            bankBranch: data.BankBranch,
          }));
          setIfscValid(true);
        } else {
          setFormData(prev => ({
            ...prev,
            bankName: '',
            bankBranch: '',
          }));
          setIfscValid(false);
          toast.error('Bank details not found for the given IFSC.');
        }
      } catch (err) {
        console.error('Failed to fetch bank details:', err);
        setFormData(prev => ({
          ...prev,
          bankName: '',
          bankBranch: '',
        }));
        setIfscValid(false);
        toast.error('Unable to fetch bank details, enter manually');
      }
    } else {
      setIfscValid(true);
    }
  };

  fetchBankDetails();
}, [formData.ifscCode]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    const alphaOnly = /^[A-Za-z\s]*$/;

    if (name === 'lastName') {
      if (!alphaOnly.test(value)) {
        toast.error("Last Name must contain only letters.");
        return;
      }
      if (value.length > 50) {
        toast.error("Last Name cannot exceed 50 characters.");
        return;
      }
    }

    if (name === 'emailId') {
      const trimmedValue = value.trim();
      if (trimmedValue.length > 100) {
        toast.error("Email cannot exceed 100 characters.");
        return;
      }
    }

    if (name === 'password') {
      if (value.length > 7) {
        toast.error("Password must be at least 7 characters.");
        return;
      }
    }

     if (name === 'confirmPassword') {
      if (value.length > 7) {
        toast.error("Confirm Password must be at least 7 characters.");
        return;
      }
    }

    const numericOnly = /^[0-9]*$/;
    if (name === 'mobileNumber' || name === 'alternateMobileNumber') {
      if (!numericOnly.test(value)) {
        toast.error(`${name === 'mobileNumber' ? 'Mobile' : 'Alternate mobile'} number must contain only digits.`);
        return;
      }
      if (name === 'mobileNumber' && value.length > 10) {
    toast.error('Mobile number must be exactly 10 digits.');
    return;
  }

  if (name === 'alternateMobileNumber' && value.length > 20) {
    toast.error('Alternate mobile number cannot exceed 20 digits.');
    return;
  }
      if (
        (name === 'mobileNumber' && value === formData.alternateMobileNumber) ||
        (name === 'alternateMobileNumber' && value === formData.mobileNumber)
      ) {
        toast.error("Mobile number and alternate mobile number cannot be the same.");
        return;
      }
    }

    if (name === 'accountHolderName') {
      setFormData((prevData) => ({
        ...prevData,
        firmName: value,  
      }));
    }

    if (name === 'accountHolderName') {
  const accountHolderRegex = /^[A-Za-z0-9\s\/.&]*$/;

  if (!accountHolderRegex.test(value)) {
    toast.error("Account Holder Name can only contain letters, numbers, spaces, & , / and .");
    return;
  }

  if (value.length > 100) {
    toast.error("Account Holder Name cannot exceed 100 characters.");
    return;
  }
}

    const digitsOnly = /^[0-9]*$/;
    if (name === 'accountNumber') {
      if (!digitsOnly.test(value)) {
        toast.error("Account Number must contain only digits. No letters, spaces, or special characters.");
        return;
      }
      if (value.length > 20) {
        toast.error("Account Number cannot exceed 20 digits.");
        return;
      }
    }

    const ifscValue = value.toUpperCase();
    if (name === 'ifscCode') {
      const validIFSC = /^[A-Za-z0-9]*$/;
      if (!validIFSC.test(ifscValue)) {
        toast.error("IFSC Code must be alphanumeric only.");
        return;
      }
      if (ifscValue.length > 15) {
        toast.error("IFSC Code cannot exceed 15 characters.");
        return;
      }
    }

    if (name === 'gst') {
      const gstValue = value.toUpperCase();
      if (gstValue.length > 15) {
        toast.error('GST number cannot exceed 15 characters.');
        return;
      }
      if (/\s/.test(gstValue)) {
        toast.error('GST number must not contain spaces.');
        return;
      }
      if (/[^A-Z0-9]/.test(gstValue)) {
        toast.error('GST number must not contain special characters.');
        return;
      }
      const firstTwo = gstValue.slice(0, 2);
      if (!/^\d{0,2}$/.test(firstTwo)) {
        toast.error('First two characters of GST must be digits.');
        return;
      }
      const nextTen = gstValue.slice(2, 12);
      if (nextTen && !/^[A-Z0-9]*$/.test(nextTen)) {
        toast.error('Characters 3 to 12 must be alphanumeric only.');
        return;
      }
      if (gstValue.length === 15) {
  const token = localStorage.getItem("token");

  axios
    .get(`${BASE_URL}/Registration/CheckGSTExists/${gstValue}`)
    .then((res) => {
      if (res.data.exists) {
        toast.error("GST number already exists.");
        setFormData((prev) => ({
          ...prev,
          gst: "",
        }));
      }
    })
    .catch((err) => {
      console.error("Error checking GST:", err);
      toast.error("Failed to verify GST number.");
    });
}
    }

    if (name === 'firmName') {
      const valueWithoutSpaces = value.replace(/\s/g, '');
      if (value.length > 100) {
        toast.error('Firm Name cannot exceed 100 characters.');
        return;
      }
    }

    if (name === 'address') {
      if (value.length > 300) {
        toast.error("Address cannot exceed 300 characters.");
        return;
      }
    }

    const pinValue = /^[0-9]*$/;
    if (name === 'pinCode') {
      if (!pinValue.test(value)) {
        toast.error("PIN Code must contain only digits. No letters, spaces, or special characters.");
        return;
      }
      if (value.length > 6) {
        toast.error("PIN Code cannot exceed 6 digits.");
        return;
      }
    }
    

    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData(prev => ({
      ...prev,
      companyLogo: file,
    }));
    setExistingLogo(null);
  };
   const handleSubmit = async (e) => {
  e.preventDefault();

  if (!isEdit && formData.password !== formData.confirmPassword) {
    toast.error('Password and Confirm Password does not match');
    return;
  }

  if (formData.gst.length < 15) {
    toast.error('GST Number must be 15 Characters Length');
    return;
  }

  const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[A-Z]{1}[0-9A-Z]{1}$/;

  if (!gstRegex.test(formData.gst)) {
    toast.error('Invalid GST format. Example: 01ABCDE1234F1Z5');
    return;
  }

  // ---------------- EDIT MODE ------------------
  if (isEdit) {
    try {
      const formDataToSend = new FormData();
      Object.keys(formData).forEach((key) => {
        if (key === 'companyLogo' && formData[key]) {
          formDataToSend.append(key, formData[key]);
        } else if (formData[key] !== '' && formData[key] !== null) {
          formDataToSend.append(key, formData[key]);
        }
      });

      await axios.put(
        `${BASE_URL}/Registration/UpdateRegistration/${formData.id}`,
        formDataToSend
      );

      toast.success("Registration updated successfully");
      navigate('/GetAllRegistrations');

    } catch (err) {
      console.error('Update failed:', err);
      toast.error('Failed to update registration');
    }
    return;
  }

  // ************************************************************
  // ⭐ DATE BASED RAZORPAY ENABLE / DISABLE LOGIC STARTS HERE ⭐
  // ************************************************************
  const today = new Date();
  const enableRazorpayFrom = new Date("2026-04-01");  // 1 April 2026
  alert(enableRazorpayFrom);

  // 🔴 Disable Razorpay till 31 March 2026
  if (today < enableRazorpayFrom) {

    setTimeout(() => {
  toast.info("Razorpay payment is temporarily disabled until 01-Apr-2026.", {
    autoClose: 4000 // show for 4 seconds (optional)
  });
}, 4000); // 2 second delay

    try {
      const formDataToSend = new FormData();
      Object.keys(formData).forEach((key) => {
        if (key === 'companyLogo' && formData[key]) {
          formDataToSend.append(key, formData[key]);
        } else if (formData[key] !== '' && formData[key] !== null) {
          formDataToSend.append(key, formData[key]);
        }
      });

      await axios.post(`${BASE_URL}/Registration/AddRegistration`, formDataToSend);

      navigate('/ThankYou');
      return;

    } catch (err) {
      console.error("Registration failed:", err);
      toast.error("Failed to save registration");
      return;
    }
  }

  // ************************************************************
  // 🟢 FROM 01 APRIL 2026 → NORMAL RAZORPAY FLOW CONTINUES
  // ************************************************************
  const scriptLoaded = await loadRazorpayScript();
  if (!scriptLoaded) {
    alert('Razorpay SDK failed to load. Are you online?');
    return;
  }

  try {
    let finalAmount = 0;
    let discountPercent = 0;

    const discountRes = await axios.get(`${BASE_URL}/Discount/GetActiveDiscount`);
    const discount = discountRes.data.data;

    if (discount) {
      discountPercent = discount.discountPercent;
      const discountValue = (discountPercent / 100) * discount.amount;
      finalAmount = discount.amount - discountValue;
    }

    const finalAmountWithGST = finalAmount + (finalAmount * 18 / 100);

    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const financialYear = month >= 4 ? `${year}-${year + 1}` : `${year - 1}-${year}`;

    const options = {
      key: 'rzp_live_rT0exN68NQKT7n',
      amount: Math.round(finalAmountWithGST * 100),
      currency: 'INR',
      name: 'Eas Up Tax',
      description: 'Transaction',
      prefill: {
        name: `${formData.firstName} ${formData.lastName}`,
        email: formData.emailId,
        contact: formData.mobileNumber
      },
      notes: {
        address: formData.address || 'N/A'
      },
      theme: {
        color: '#F37254'
      },

      handler: async function (response) {
        alert(`Payment successful! Payment ID: ${response.razorpay_payment_id}`);

        const orderPayload = {
          GstNumber: formData.gst,
          FinancialYear: financialYear,
          OrderAmount: finalAmount,
          Discount: discountPercent,
          FinalAmount: finalAmount
        };

        try {
          await axios.post(`${BASE_URL}/Order/AddOrder`, orderPayload);

          const formDataToSend = new FormData();
          Object.keys(formData).forEach((key) => {
            if (key === 'companyLogo' && formData[key]) {
              formDataToSend.append(key, formData[key]);
            } else if (formData[key] !== '' && formData[key] !== null) {
              formDataToSend.append(key, formData[key]);
            }
          });

          await axios.post(`${BASE_URL}/Registration/AddRegistration`, formDataToSend);

          navigate('/ThankYou');

        } catch (err) {
          console.error('Error after payment:', err);
          toast.error('Payment done, but something went wrong while saving registration or order.');
        }
      }
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();

  } catch (error) {
    console.error('Error in handleSubmit:', error);
    toast.error('Something went wrong during initialization.');
  }
};

  return (
    <GSTLoader>
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      {isEdit ? <LayoutAdminHeader /> : <LayoutLandingHeader />}
      <Dialog open={!showForm && !isEdit}>
        <DialogTitle>Terms & Conditions</DialogTitle>
        <DialogContent dividers>
          <Typography>
            By proceeding, you agree to provide accurate information. This data will be used for your registration
            and verification purposes only. Please review the fields carefully before submission.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowForm(true)} variant="contained" color="primary">I Agree</Button>
        </DialogActions>
      </Dialog>

      {showForm && (
        <Box sx={{ padding: 4, backgroundColor: '#f5f5f5' }}>
          <Typography
  variant="h5"
  gutterBottom
  align="center"
  fontWeight="bold"
  sx={{ color: '#004080' }}
>
  {isEdit ? 'Edit' : 'User'} Registration
</Typography>

          <form onSubmit={handleSubmit}>
            <Paper sx={{ padding: 3, mb: 3 }}>
              <Typography variant="h6">Personal Details</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="First Name"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Last Name"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Email"
                    name="emailId"
                    value={formData.emailId}
                    onChange={handleChange}
                    fullWidth
                    required
                  />
                </Grid>
                {!isEdit && (
                  <>
                    <Grid item xs={12} sm={4}>
                      <TextField
          label="Password"
          name="password"
          type={showPassword ? 'text' : 'password'} 
          value={formData.password}
          onChange={handleChange}
          fullWidth
          required
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField
          label="Confirm Password"
          name="confirmPassword"
          type={showConfirmPassword ? 'text' : 'password'} // Toggle the type
          value={formData.confirmPassword}
          onChange={handleChange}
          fullWidth
          required
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle confirm password visibility"
                  onClick={handleClickShowConfirmPassword}
                  edge="end"
                >
                  {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
                    </Grid>
                  </>
                )}
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Mobile Number"
                    name="mobileNumber"
                    value={formData.mobileNumber}
                    onChange={handleChange}
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Alternate Mobile Number"
                    name="alternateMobileNumber"
                    value={formData.alternateMobileNumber}
                    onChange={handleChange}
                    fullWidth
                  />
                </Grid>
                {!isEdit && (
  <>
    <Grid item xs={12} sm={4}>
      <TextField
        label="Security Question"
        name="securityQuestion"
        value={formData.securityQuestion}
        onChange={handleChange}
        select
        fullWidth
        required
        sx={{ width: '250px' }}
      >
        <MenuItem value="Work Place">Work Place</MenuItem>
        <MenuItem value="First Vehicle">First Vehicle</MenuItem>
      </TextField>
    </Grid>

    <Grid item xs={12} sm={4}>
      <TextField
        label="Security Answer"
        name="securityAnswer"
        value={formData.securityAnswer}
        onChange={handleChange}
        fullWidth
        required
      />
    </Grid>
  </>
)}
              </Grid>
            </Paper>

            <Paper sx={{ padding: 3, mb: 3 }}>
              <Typography variant="h6">Bank Details</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Account Holder Name"
                    name="accountHolderName"
                    value={formData.accountHolderName}
                    onChange={handleChange}
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Account Number"
                    name="accountNumber"
                    value={formData.accountNumber}
                    onChange={handleChange}
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="IFSC Code"
                    name="ifscCode"
                    value={formData.ifscCode}
                    onChange={handleChange}
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
  label="Bank Name"
  name="bankName"
  value={formData.bankName}
  onChange={handleChange}
  fullWidth
  disabled={ifscValid}
/>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
  label="Bank Branch"
  name="bankBranch"
  value={formData.bankBranch}
  onChange={handleChange}
  fullWidth
  disabled={ifscValid}
/>
                </Grid>
              </Grid>
            </Paper>

            <Paper sx={{ padding: 3 }}>
              <Typography variant="h6">Company / Firm Details</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="GST Number"
                    name="gst"
                    value={formData.gst}
                    onChange={handleChange}
                    fullWidth
                    required
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <TextField
                    label="State"
                    name="stateName"
                    value={formData.stateName}
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    required
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <TextField
                    select
                    label="District"
                    name="district"
                    value={formData.district}
                    onChange={handleChange}
                    fullWidth
                    required
                    disabled={!formData.state}
                    sx={{ width: '250px' }}
                  >
                    {districts.map(d => (
                      <MenuItem key={d.id} value={d.id}>{d.districtName}</MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
        label="Firm Name"
        name="firmName"
        value={formData.firmName}
        onChange={handleChange}
        fullWidth
        required
        slotProps={{
          htmlInput: {
            readOnly: formData.accountHolderName !== "",  
          },
        }}
      />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Address"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    fullWidth
                    multiline
                    rows={2}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Pin Code"
                    name="pinCode"
                    value={formData.pinCode}
                    onChange={handleChange}
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  {existingLogo && (
                    <Box sx={{ mb: 2 }}>
                      <Typography variant="body2">Current Logo:</Typography>
                      <Avatar
                        src={`${BASE_URL}/${existingLogo}`}
                        alt="Company Logo"
                        sx={{ width: 100, height: 100, mt: 1 }}
                        variant="square"
                      />
                    </Box>
                  )}
                  <TextField
                    type="file"
                    label="Company Logo"
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    onChange={handleFileChange}
                    inputProps={{ accept: 'image/*' }}
                  />
                  {formData.companyLogo && (
                    <Typography variant="body2" sx={{ mt: 1 }}>
                      Selected file: {formData.companyLogo.name}
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </Paper>

            <Box sx={{ textAlign: 'center', mt: 3 }}>
              <Button variant="contained" type="submit" color="primary">
                {isEdit ? 'Update' : 'Register'}
              </Button>
            </Box>
          </form>
        </Box>
      )}
    </>
    </GSTLoader>
  );
};

export default AddPayment;



